import AddProducts from './AddProducts';

export default AddProducts;
